import * as i from 'types';

import PercentBoxIcon from 'vectors/icons/percent-box.svg';
import EuroBoxIcon from 'vectors/icons/euro-box.svg';
import HandBoxIcon from 'vectors/icons/hand-box.svg';

export const servicePackages: i.ServicePackage[] = [
  {
    icon: PercentBoxIcon,
    service: {
      label: 'Basis',
      value: 'basis',
    },
    description: 'Maak gebruik van onze gratis diensten en partnerdeals.',
    colorVariant: 'dark',
    checkmarks: [
      {
        title: 'Electrifleet intake',
        description: 'Bespreek al jouw praktische vragen en bepaal een actieplan hoe over te gaan op elektrisch.',
      },
      {
        title: 'Partners en deals',
        description: 'Ontdek welke experts jouw elektrificatie kunnen versnellen en ontvang de beste deals.',
      },
    ],
    price: 'Gratis',
  },
  {
    icon: EuroBoxIcon,
    service: {
      label: 'Slim',
      value: 'slim',
    },
    description: 'Ervaar ons specialistisch advies en krijg meer financiële voordelen.',
    colorVariant: 'light',
    checkmarks: [
      {
        title: 'Electrifleet intake',
        description: 'Bespreek al jouw praktische vragen en bepaal een actieplan hoe over te gaan op elektrisch.',
      },
      {
        title: 'Partners & deals',
        description: 'Ontdek welke experts jouw elektrificatie kunnen versnellen en ontvang de beste deals.',
      },
      {
        title: 'EV Business Impact Assessment',
        description: 'Uitgebreid advies over elektrificatie van jouw bedrijfsvoertuigen. Online, wel zo makkelijk.',
      },
      {
        title: 'Subsidies en fiscale voordelen',
        description: 'Wij vragen de juiste subsidies voor je aan (SEBA) en adviseren je over belastingvoordeel (MIA). Bespaar duizenden euro’s.',
      },
    ],
    price: {
      oldPrice: '900',
      newPrice: '450',
    },
  },
  {
    icon: HandBoxIcon,
    service: {
      label: 'Op maat',
      value: 'op',
    },
    description: 'Onze coach begeleidt en ontzorgt je. Eenvoudig en effectief.',
    colorVariant: 'dark',
    checkmarks: [
      {
        title: 'Electrifleet intake',
        description: 'Bespreek al jouw praktische vragen en bepaal een actieplan hoe over te gaan op elektrisch.',
      },
      {
        title: 'Partners & deals',
        description: 'Ontdek welke experts jouw elektrificatie kunnen versnellen en ontvang de beste deals.',
      },
      {
        title: 'EV Business Impact Assessment',
        description: 'Uitgebreid advies over elektrificatie van jouw bedrijfsvoertuigen. Wij komen naar je toe op locatie.',
      },
      {
        title: 'Subsidies en fiscale voordelen',
        description: 'Wij vragen de juiste subsidies voor je aan (SEBA) en adviseren je over belastingvoordeel (MIA). Bespaar duizenden euro\'s.',
      },
      {
        title: 'Implementatie coach',
        description: 'Wij begeleiden en ontzorgen je tijdens de implementatie. Ook maken we een persoonlijke TCO-berekening met jouw gemaakte keuzes.',
      },
    ],
    price: {
      oldPrice: '2500',
      newPrice: '1250*',
    },
  },
];
